import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useRecordShellEnabled } from '../../../components/RecordShell/recordShellFlag';
import { useFeatureFlag } from '../../../contexts/featureFlagContext';
import { RfiResponseWorkspacePage } from '../RfiResponseWorkspacePage';
import { RfiCapabilityStatementPage } from './RfiCapabilityStatementPage';
import { RfiChatHistoryPage } from './RfiChatHistoryPage';
import { RfiHomePage } from './RfiHomePage';
import { RfiLaborCategoriesPage } from './RfiLaborCategoriesPage';
import { RfiNoticePage } from './RfiNoticePage';
import { RfiPastAnswersPage } from './RfiPastAnswersPage';
import { RfiQaAmendmentsPage } from './RfiQaAmendmentsPage';
import { RfiQuestionPage } from './RfiQuestionPage';
import { RfiQuestionsIndex } from './RfiQuestionsIndex';
import { RfiReviewsPage } from './RfiReviewsPage';
import { RfiTeamPage } from './RfiTeamPage';
export const WRITING_WORKSPACE_FLAG = 'writing_workspace_v1';
/** Pages that open the response document need `writing_workspace_v1` too. */ const WRITING_PAGES = new Set([
    'document',
    'questions',
    'question'
]);
/**
 * One child route of `rfi-response/:id` (WRT-05). With the record shell off,
 * or for `new`, every child renders today's `RfiResponseWorkspacePage` (as
 * FND-19's wildcard did). Response-document pages also need
 * `writing_workspace_v1`; without it they redirect to `legacy`.
 */ export function RfiSectionGate({ page }) {
    const { id = '' } = useParams();
    const [params] = useSearchParams();
    const shellOn = useRecordShellEnabled();
    const writingOn = useFeatureFlag(WRITING_WORKSPACE_FLAG) === true;
    if (!shellOn || id === 'new') return /*#__PURE__*/ _jsx(RfiResponseWorkspacePage, {});
    const base = `/rfi-response/${id}`;
    // Old deep links: ?section=<id> → that question; ?rfiPanel=ask → the first question's Assist.
    const section = params.get('section');
    if ((page === 'home' || page === 'document') && section && writingOn) {
        return /*#__PURE__*/ _jsx(Navigate, {
            replace: true,
            to: `${base}/questions/${section}`
        });
    }
    if (page === 'home' && params.get('rfiPanel') === 'ask' && writingOn) {
        return /*#__PURE__*/ _jsx(Navigate, {
            replace: true,
            to: `${base}/questions?side=assist`
        });
    }
    if (WRITING_PAGES.has(page) && !writingOn) return /*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: `${base}/legacy`
    });
    switch(page){
        case 'home':
            return /*#__PURE__*/ _jsx(RfiHomePage, {});
        case 'document':
            return /*#__PURE__*/ _jsx(RfiQuestionPage, {
                mode: "document"
            });
        case 'questions':
            return /*#__PURE__*/ _jsx(RfiQuestionsIndex, {});
        case 'question':
            return /*#__PURE__*/ _jsx(RfiQuestionPage, {
                mode: "question"
            });
        case 'capability-statement':
            // writing_workspace_v1 off: the page itself links to /legacy (WRT-07 AC 4).
            return /*#__PURE__*/ _jsx(RfiCapabilityStatementPage, {});
        case 'reviews':
            return /*#__PURE__*/ _jsx(RfiReviewsPage, {});
        case 'chat':
            return /*#__PURE__*/ _jsx(RfiChatHistoryPage, {});
        case 'notice':
            return /*#__PURE__*/ _jsx(RfiNoticePage, {});
        case 'labor-categories':
            return /*#__PURE__*/ _jsx(RfiLaborCategoriesPage, {});
        case 'amendments':
            return /*#__PURE__*/ _jsx(RfiQaAmendmentsPage, {});
        case 'team':
            return /*#__PURE__*/ _jsx(RfiTeamPage, {});
        case 'past-answers':
            // WRT-07 (v2.2): cp0 search over approved answers of other RFIs.
            return /*#__PURE__*/ _jsx(RfiPastAnswersPage, {});
        default:
            // Past answers (WRT-07 page 7, built separately): today's workspace until it lands.
            return /*#__PURE__*/ _jsx(RfiResponseWorkspacePage, {});
    }
}
